<div class="relative w-full">
  <button
    #datepickerTriggerButton
    (click)="prepareDateSelection()"
    type="button"
    class="focus-link"
    [attr.aria-label]="internalDate | localizeDate: dateFormat:'noTimezone'"
    [attr.aria-expanded]="isSelectingDate && !disabled"
    aria-controls="datepickerPanel">
    <input
      tabindex="-1"
      class="input-section input-height typo-text-mobile lg:typo-text-desktop w-full cursor-pointer rounded-md px-4 py-2"
      readonly
      (keydown)="inputKeyDown($event)"
      (blur)="focusOutInputField($event)"
      aria-hidden="true"
      [class.highlighted]="isSelectingDate"
      [value]="internalDate | localizeDate: dateFormat:'noTimezone'"
      [disabled]="disabled" />
    <rd-shared-icon
      class="icon starting-date-icon absolute right-3 inline-block h-4 cursor-pointer"
      iconSymbol="icon-calendar"
      iconTheme="link"
      tabindex="-1"
      aria-hidden="true">
    </rd-shared-icon>

    <mat-select
      #datePickerContainer
      disableRipple
      disableOptionCentering
      class="solid invisible absolute left-0 rounded-md border border opacity-0"
      [aria-label]="
        'order.manage.auto_redemption.gc_specific_amount_form.starting_date'
          | translate
      ">
      <mat-option
        disabled
        class="auto-redemption-date-picker-option"
        role="dialog"
        aria-modal="true">
        <rd-auto-redemption-date-picker
          [defaultDate]="internalDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [formControl]="
            datePickerFormControl
          "></rd-auto-redemption-date-picker>
      </mat-option>
    </mat-select>
  </button>
</div>
